import { validateOnlyEmailFormat } from '../utilities/utility';
import { formPost, jsonPost, jsonGet } from '../components/ajax';
import { API_REFERENCE } from '../utilities/constant_api';

const forgotPwd = 'mfa-forgot-password';
const mfaEnterCode = 'mfa-enter-code';
const mfaEnterCodeSelector = `.${mfaEnterCode}`;
const forgotPwdSelector = `.${forgotPwd}`;
const forgotPwdError = `${forgotPwdSelector}__error`;
const forgotPwdInlineError = `${forgotPwdSelector}__inline`;
const forgotPwdEmailAddress = `${forgotPwdSelector}__email`;
const forgotPwdSmsBtn = `${forgotPwdSelector}__btn--sms`;
const forgotPwdVoiceBtn = `${forgotPwdSelector}__btn--voice`;
const forgotPwdEmailBtn = `${forgotPwdSelector}__btn--email`;
const forgotPwdSmsBtnCls = `${forgotPwd}__btn--sms`;
const forgotPwdVoiceBtnCls = `${forgotPwd}__btn--voice`;
const forgotPwdEmailBtnCls = `${forgotPwd}__btn--email`;
const forgotPwdErrorInvalid = `${forgotPwdError}--invalid`;
const forgotPwdErrorInlineInvalid = `${forgotPwdInlineError}--invalid`;
const forgotPwdErrorInlineEmpty = `${forgotPwdInlineError}--empty`;
const forgotPwdErrorWarningMsg = `${forgotPwdError}--warning`;
const forgotPwdInner = `${forgotPwdSelector}__inner`;
const forgotPwdForm = `${forgotPwdSelector}__form`;
const forgotPwdExpiryLink = `${forgotPwdSelector}__error--expired`;

const mfaEnterCodeErrorMsg = `${mfaEnterCodeSelector}__error-msg`;
const mfaEnterCodeErrorMsgInvalid = `${mfaEnterCodeErrorMsg}--invalid`;
const mfaEnterCodeRepeatSpan = `${mfaEnterCodeSelector}__repeat`;
const mfaEnterCodeWarnMsg = `${mfaEnterCodeSelector}__warn-msg`;
const mfaEnterCodeHeadingMsg = `${mfaEnterCodeSelector}__heading`;
const mfaEnterCodeRepeatBtn = `${mfaEnterCodeSelector}__rep-btn`;
const mfaEnterCodeParent = `${mfaEnterCode}-parent`;
const mfaEnterCodeErrorMsgExpired = `${mfaEnterCodeErrorMsg}--expired`;
const mfaEnterCodeField = `${mfaEnterCodeSelector}__code`;
const mfaEnterCodeForm = `${mfaEnterCodeSelector}__form`;
const mfaEnterCodeVerifyBtn = `${mfaEnterCodeSelector}__ver-btn`;
const mfaEnterCodeEmailLink = `${mfaEnterCodeSelector}__email-link`;
const forgotPasswordLinkExpiry = '#forgotPasswordLinkExpiry';

const smsFactorType = 'sms';
const callFactorType = 'call';
const emailFactorType = 'email';
const sentAction = 'sent';
const resendAction = 'resend';
const callingAction = 'calling';
const redialAction = 'redial';

let isSmsBtnClicked = false;
let isVoiceCallBtnClicked = false;
let isEmailBtnClicked = false;
let mfaFpSendEmailAjaxRequest = true;
let mfaFpVerifyOtpAjaxRequest = true;
let resendActivationUrl;
let idleSecondsCounter = 0;
let mfaSessionTimeOutFlag = false;
let IDLE_TIMEOUT = $('#sessionTime').val();
let cboxOptions = {
  maxWidthLg: '550px',
  maxHeightLg: '800px',
  maxWidthMd: '550px',
  maxHeightMd: '500px',
  maxWidthSm: 'auto',
  maxHeightSm: 'auto'
};
let cboxOptionsEmail = {
  maxWidthLg: '513px',
  maxHeightLg: '585px',
  maxWidthMd: '513px',
  maxHeightMd: '585px',
  maxWidthSm: '360px',
  maxHeightSm: '596px'
};
let mfaSessionTimeout = $('#sessionTime').val() / 60;
const submitEmailIdToFactorUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.resetPassword.submitEmailIdToFactor}`;
const verifyOtpUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.resetPassword.verifyOtpCode}`;
const emailConfirmationUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.resetPassword.emailConfirmationPage}`;
const newPasswordUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.resetPassword.newPasswordPage}`;
let legacyUserCheckUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.resetPassword.legacyUserCheck}`;

const forgotPasswordMfa = {
  checkWidth() {
    if (window.innerWidth >= 1368) {
      return cboxOptions.maxWidthLg;
    } else if (window.innerWidth >= 768 && window.innerWidth < 1368) {
      return cboxOptions.maxWidthMd;
    } else {
      return cboxOptions.maxWidthSm;
    }
  },
  checkHeight() {
    if (window.innerHeight >= 1368) {
      return cboxOptions.maxHeightLg;
    } else if (window.innerHeight >= 768 && window.innerHeight < 1368) {
      return cboxOptions.maxHeightMd;
    } else {
      return cboxOptions.maxHeightSm;
    }
  },
  checkWidthEmail() {
    if (window.innerWidth >= 1368) {
      return cboxOptionsEmail.maxWidthLg;
    } else if (window.innerWidth >= 768 && window.innerWidth < 1368) {
      return cboxOptionsEmail.maxWidthMd;
    } else {
      return cboxOptionsEmail.maxWidthSm;
    }
  },
  checkHeightEmail() {
    if (window.innerHeight >= 1368) {
      return cboxOptionsEmail.maxHeightLg;
    } else if (window.innerHeight >= 768 && window.innerHeight < 1368) {
      return cboxOptionsEmail.maxHeightMd;
    } else {
      return cboxOptionsEmail.maxHeightSm;
    }
  },
  showInvalidEmailAddressMessages() {
    $(`${forgotPwdError},${forgotPwdInlineError}`).hide();
    const thisObj = $(this);
    forgotPasswordMfa.validateEmailAddressFormat(thisObj);
    $('#username').val($(this).val());
  },
  validateEmailAddressFormat(emailAddressField) {
    emailAddressField.removeClass('error');
    const emailAddress = emailAddressField.val();
    const isAddressValid = validateOnlyEmailFormat(emailAddress);
    if (!isAddressValid) {
      $(`${forgotPwdErrorInvalid},${forgotPwdErrorInlineInvalid}`).show();
      emailAddressField.addClass('error');
    }
    return isAddressValid;
  },

  validateFieldEmpty(field) {
    const fieldObj = field[0];
    const isEmailEmpty = fieldObj.validity.valueMissing;
    const isEnterCodePresent = $(mfaEnterCodeSelector).css('display');
    if (isEmailEmpty) {
      $(`${forgotPwdErrorInvalid},${forgotPwdErrorInlineEmpty}`).show();
      field.addClass('error');
      if (isEnterCodePresent === 'block') {
        $(mfaEnterCodeErrorMsgInvalid).show();
      }
    }
    return isEmailEmpty;
  },
  hideShowBtnTexts(isSmsOrVoice, isSmsOrVoiceSelector) {
    // adding aria-label for accessibility BEGINS
    const selectedSpanText = $(
      `${mfaEnterCodeRepeatSpan}--${isSmsOrVoice}-${isSmsOrVoiceSelector}`
    )
      .text()
      .trim();
    $(mfaEnterCodeRepeatBtn).attr('aria-label', selectedSpanText);
    // adding aria-label for accessibility ENDS
    $(
      `${mfaEnterCodeRepeatSpan},${mfaEnterCodeWarnMsg},${forgotPwdErrorWarningMsg}`
    ).hide();
    $(
      `${mfaEnterCodeHeadingMsg}--${isSmsOrVoice},${mfaEnterCodeRepeatSpan}--${isSmsOrVoice}-${isSmsOrVoiceSelector}`
    ).show();

    if (
      isSmsOrVoiceSelector === resendAction ||
      isSmsOrVoiceSelector === redialAction
    ) {
      $(
        `${forgotPwdErrorWarningMsg},${mfaEnterCodeWarnMsg}--${isSmsOrVoice}`
      ).show();
    }
  },
  enableResendRedialAfter30() {
    const isSmsOrVoice = isSmsBtnClicked ? smsFactorType : callFactorType;
    let isSmsOrVoiceSelector = isSmsBtnClicked ? sentAction : callingAction;
    forgotPasswordMfa.hideShowBtnTexts(isSmsOrVoice, isSmsOrVoiceSelector);
    setTimeout(function() {
      $(mfaEnterCodeRepeatBtn).attr('disabled', false);
      isSmsOrVoiceSelector = isSmsBtnClicked ? resendAction : redialAction;
      forgotPasswordMfa.hideShowBtnTexts(isSmsOrVoice, isSmsOrVoiceSelector);
    }, 30000);
  },
  navigateToSpecificPage(requiredUrl) {
    window.location.replace(requiredUrl);
  },
  initializeMfaEnterCodeScreen() {
    const mfaEnterCodeObj = $(mfaEnterCodeSelector);
    $(forgotPwdInner).hide();
    mfaEnterCodeObj.show();
    mfaEnterCodeObj.parents(forgotPwdSelector).addClass(mfaEnterCodeParent);
    $(window).scrollTop(0);
    forgotPasswordMfa.enableResendRedialAfter30();
  },
  moveToNextStepToReset(stateToken, emailId, factorType) {
    if (factorType === smsFactorType || factorType === callFactorType) {
      forgotPasswordMfa.initializeMfaEnterCodeScreen();
    } else {
      // navigate to email confirmation page
      const completeEmailConfirmationUrl = `${emailConfirmationUrl}?token=${stateToken}&email=${emailId}`;
      forgotPasswordMfa.navigateToSpecificPage(completeEmailConfirmationUrl);
    }
  },
  sendEmailIdToFactor(action, factorType) {
    let forgotPwdEmailFormData = $(forgotPwdForm).serialize();
    forgotPwdEmailFormData += `&factorType=${factorType}`;
    if (!mfaFpSendEmailAjaxRequest) return false;
    mfaFpSendEmailAjaxRequest = false;
    let legacyUserCheckUrlFinal = `${legacyUserCheckUrl}?emailId=${encodeURIComponent($(
      '#username'
    ).val())}`;
    jsonGet(legacyUserCheckUrlFinal)
      .then(response => {
        if (response == true) {
          $('.legacy_password_reset').submit();
        } else {
          formPost(submitEmailIdToFactorUrl, forgotPwdEmailFormData)
            .then(response => {
              mfaFpSendEmailAjaxRequest = true;
              if (
                JSON.parse(response).status.toUpperCase() === 'FAILURE' &&
                JSON.parse(response).recoveryToken !== null &&
                JSON.parse(response).recoveryToken !== ''
              ) {
                ACC.colorbox.open('', {
                  escKey: false,
                  overlayClose: false,
                  closeButton: false,
                  html: $('#email-notification-overlay').html(),
                  onLoad: $('#cboxOverlay').css('position', 'fixed'),
                  width: forgotPasswordMfa.checkWidthEmail(),
                  height: forgotPasswordMfa.checkHeightEmail(),
                  className: 'email-notification-overlay-main'
                });
                startCountDown();
                resendActivationUrl = JSON.parse(response).recoveryToken;
              } else {
                const { recoveryToken, emailId } = JSON.parse(response);
                if (action === sentAction) {
                  forgotPasswordMfa.moveToNextStepToReset(
                    recoveryToken,
                    emailId,
                    factorType
                  );
                } else if (action === resendAction) {
                  forgotPasswordMfa.enableResendRedialAfter30();
                }
              }
            })
            .catch(error => {
              mfaFpSendEmailAjaxRequest = true;
              if (mfaSessionTimeOutFlag) {
                $('#mfaSessionTimeOut').text(mfaSessionTimeout);
                forgotPasswordMfa.openSessionTimeoutOverlay();
              }
            });
        }
      })
      .catch(error => {
        mfaFpSendEmailAjaxRequest = true;
        if (mfaSessionTimeOutFlag) {
          $('#mfaSessionTimeOut').text(mfaSessionTimeout);
          forgotPasswordMfa.openSessionTimeoutOverlay();
        }
      });
  },
  decideFactorType() {
    let factorType = isSmsBtnClicked ? smsFactorType : callFactorType;
    factorType = isEmailBtnClicked ? emailFactorType : factorType;
    return factorType;
  },
  navigateToRespectiveSection() {
    const thisObj = $(this);
    const emailAddressField = thisObj
      .parents(forgotPwdSelector)
      .find(forgotPwdEmailAddress);

    const isEmailAddressValid = forgotPasswordMfa.validateEmailAddressFormat(
      emailAddressField
    );
    const isEmailAddressEmpty = forgotPasswordMfa.validateFieldEmpty(
      emailAddressField
    );
    isSmsBtnClicked = thisObj.hasClass(forgotPwdSmsBtnCls);
    isVoiceCallBtnClicked = thisObj.hasClass(forgotPwdVoiceBtnCls);
    isEmailBtnClicked = thisObj.hasClass(forgotPwdEmailBtnCls);
    const factorType = forgotPasswordMfa.decideFactorType();
    if (isEmailAddressValid && !isEmailAddressEmpty) {
      if (isSmsBtnClicked || isVoiceCallBtnClicked || isEmailBtnClicked) {
        forgotPasswordMfa.sendEmailIdToFactor(sentAction, factorType);
      }
    }
  },
  sendOtpToFactor() {
    const thisObj = $(this);
    thisObj.attr('disabled', true);
    const factorType = forgotPasswordMfa.decideFactorType();
    forgotPasswordMfa.sendEmailIdToFactor(resendAction, factorType);
  },
  verifyOtpCodeCorrect(entryCodeField) {
    const otpCode = entryCodeField.val();
    const verifyOtpUrlWithCode = `${verifyOtpUrl}?passCode=${otpCode}`;
    if (!mfaFpVerifyOtpAjaxRequest) return false;
    mfaFpVerifyOtpAjaxRequest = false;
    jsonPost(verifyOtpUrlWithCode)
      .then(response => {
        mfaFpVerifyOtpAjaxRequest = true;
        const { stateToken, status } = response;
        if (status === 'FAILURE') {
          $(`${forgotPwdErrorInvalid},${mfaEnterCodeErrorMsgExpired}`).show();
        } else {
          const emailId = response._embedded.user.profile.login;
          const newPwdRedirectionUrl = `${newPasswordUrl}?emailId=${emailId}&stateToken=${stateToken}`;
          forgotPasswordMfa.navigateToSpecificPage(newPwdRedirectionUrl);
        }
      })
      .catch(error => {
        mfaFpVerifyOtpAjaxRequest = true;
        if (mfaSessionTimeOutFlag) {
          $('#mfaSessionTimeOut').text(mfaSessionTimeout);
          forgotPasswordMfa.openSessionTimeoutOverlay();
        }
      });
  },
  validateAndSubmitOtpCode() {
    $(
      `${forgotPwdErrorInvalid},${mfaEnterCodeErrorMsg},${forgotPwdInlineError}`
    ).hide();
    const entryCodeField = $(this)
      .parents(forgotPwdSelector)
      .find(mfaEnterCodeField);
    entryCodeField.removeClass('error');
    const isEntryCodeFieldEmpty = forgotPasswordMfa.validateFieldEmpty(
      entryCodeField
    );
    if (!isEntryCodeFieldEmpty) {
      forgotPasswordMfa.verifyOtpCodeCorrect(entryCodeField);
    }
  },
  sendEmailForReset() {
    forgotPasswordMfa.sendEmailIdToFactor(sentAction, emailFactorType);
  },
  openSessionTimeoutOverlay() {
    ACC.colorbox.open('', {
      escKey: false,
      overlayClose: false,
      closeButton: false,
      html: $('#mfaSessionTimeoutOverlay').html(),
      onLoad: $('#cboxOverlay').css('position', 'fixed'),
      width: forgotPasswordMfa.checkWidth(),
      height: forgotPasswordMfa.checkHeight(),
      className: 'mfa-session-timeout-overlay-popup'
    });
  },
  resendEmailNotification() {
    if(resendActivationUrl != undefined){
      jsonGet(resendActivationUrl+'&activationEmailSentTime='+new Date().toLocaleString()).then(response => {
        if (response === true || response === 'true') {
          $(this)
            .parents('#cboxLoadedContent')
            .find('.resent-email-success-msg')
            .removeClass('hidden');
          $('.email-notification-overlay-container:last').scrollTop(
            $(
              '.email-notification-overlay-container:last .resent-email-success-msg'
            ).offset().top
          );
        } else if (response.toLowerCase() === 'failure') {
          window.location.href = '/';
        }
      });
    }
  },
  resetTimer() {
    idleSecondsCounter = 0;
  },
  CheckIdleTime() {
    idleSecondsCounter++;
    if (idleSecondsCounter >= IDLE_TIMEOUT) {
      mfaSessionTimeOutFlag = true;
    }
  },

  init() {
    $(
      `${forgotPwdError},${forgotPwdInlineError},${mfaEnterCodeSelector},${mfaEnterCodeHeadingMsg},${mfaEnterCodeRepeatSpan},${mfaEnterCodeWarnMsg},${mfaEnterCodeErrorMsg}`
    ).hide();

    if ($(forgotPasswordLinkExpiry).val()) {
      $(`${forgotPwdExpiryLink}`).show();
    }
    $(mfaEnterCodeRepeatBtn).attr('disabled', true);
    $(`${mfaEnterCodeForm},${forgotPwdForm}`).each((index, form) => {
      form.reset();
    });
    $(forgotPwdEmailAddress).on('input', this.showInvalidEmailAddressMessages);
    $(`${forgotPwdSmsBtn},${forgotPwdVoiceBtn},${forgotPwdEmailBtn}`).on(
      'click',
      this.navigateToRespectiveSection
    );
    $(mfaEnterCodeRepeatBtn).on('click', this.sendOtpToFactor);
    $(mfaEnterCodeVerifyBtn).on('click', this.validateAndSubmitOtpCode);
    $(mfaEnterCodeEmailLink).on('click', this.sendEmailForReset);
    $(document).on(
      'click',
      '.notification-overlay-btn',
      forgotPasswordMfa.resendEmailNotification
    );
    $('.spinner-mask').addClass('hidden');
    if ($('#forgotPasswordSessionTimeOut').val() != 'true') {
      window.setInterval(this.CheckIdleTime, 1000);
    }
    $(document).on('click', this.resetTimer);
  }
};
forgotPasswordMfa.init();
function startCountDown(){
  var button= $('#colorbox').find('#resendEmailActivationBtn');
  button.attr('disabled', true);
  var countDownDuration = 29;
  var countDown = setInterval(function(){
    countDownDuration--;
    if(countDownDuration == 0){
      button.attr('disabled', false);
      clearInterval(countDown);
    }
  },1000);
}

export default forgotPasswordMfa;
